<p-toast position="bottom-right"></p-toast>
<p-toast key="log" position="center"></p-toast>
<p-confirmDialog appendTo="body" ></p-confirmDialog>

<app-crud-table [crudService]="crudService"
                 [transPartKey]="transPartKey" [fieldId]="fieldId" [fieldName]="'title'" [fieldEnabled]="'active'"
                 [tableConfig]="tableConfig" [newRecord]="newRecord"
                 [(formRecord)]="formRecord" [formConfig]="formConfig"
                 [formLoading]="formLoading" [(records)]="records"
                 [(selectedRecords)]="selectedRecords" [(dialogFormVisible)]="dialogFormVisible"
                 [contextMenuConfig]="contextMenuConfig" [headerButtonConfig]="headerButtonConfig"
                 [prepareForCreate]="prepareRecordForCreate" [prepareForClone]="prepareRecordForClone"
                 [prepareForEdit]="prepareRecordForEdit"
                 [(tableCurrentRequest)]="tableCurrentRequest" [totalRecords]="totalRecords"
                 [dialogFormTitle]="dialogFormTitle"
></app-crud-table>

<app-cc-form-dialog [transPartKey]="transPartKey"
                   [loading]="false" [submitted]="settingsSubmitted"
                   [loadingProgressValue]="settingsFormLoadingProgressValue"
                   [(dialogFormVisible)]="settingsDialogFormVisible"
                   [formConfig]="settingsFormConfig"
                   [dialogFormTitle]="('common.edit' | translate)+' '+('page.' + transPartKey + '.settings_name' | translate)"
                   [(formRecord)]="settings"
                   (onSubmitEvent)="saveSettings()"
></app-cc-form-dialog>
